<template>
  <div class="qyGroupChat">
    <el-row>
      <el-col :span="24">
        <span v-if="selectName" style="padding: .4rem; display: block; line-height: .56rem">
          {{ selectName }} --- 私人群
          <el-button type="primary" size="mini" style="float: right" @click="handleAddItemEntry">添加事项</el-button>
        </span>
        <el-row v-scroll-loading="scrollBottom" ref="messagesList" class="messages-list" style="border: solid 1px #DCDFE6; border-radius: 5px">
          <div class="messages-con">
            <span v-if="messages.length === 0">请选择群</span>
            <span  v-else>
              <div v-for="(message, index) in messages" :key="index" class="message">
                <el-image :src="message.group_user_wx_head" style="width: 40px; height: 40px; vertical-align: middle;" fit="cover"></el-image>
                <span>{{ message.group_user_wx_nick_name }} {{ message.message_time }}</span>
                <span style="padding-left: 10px" v-if="message.type === 1">
                  <el-checkbox :checked="is_checked" @change="handleAddMessageIndex(message.message_id)"></el-checkbox>
                </span>
                <el-row class="mb-0">
                  <el-col :span="24" v-if="message.type === 1">
                    <div class="infinite-item-content">{{ message.content }}</div>
                    <div class="popper__arrow"></div>
                  </el-col>
                  <el-col v-else-if="message.type === 3">
                    <div class="record p-10 reciver">
                      <el-image v-if="message.file_url" style="width: 250px" :src="message.file_url" :preview-src-list="[message.file_url]"></el-image>
                      <el-image v-else style="width: 250px" :src="imgDefultSrc"></el-image>
                    </div>
                  </el-col>
                  <el-col v-else-if="message.type === 496">
                    <div class="record p-10 reciver">
                      <div v-if="message.file_url" class="file_warp" @click="loadFile(message.file_url, message.file_name)">
                        <div class="file_title">
                          <div class="file_text">{{ message.file_name }}</div>
                          <div class="file_sign"><i class="el-icon-document"></i></div>
                        </div>
                        <i class="file_download el-icon-download"></i>
                      </div>
                      <span v-else><i class="el-icon-loading"></i></span>
                    </div>
                  </el-col>
                  <el-col v-else-if="message.type === 47">
                    <div class="record p-10 reciver">
                      <el-image v-if="message.link_url" style="width: 250px" :src="message.link_url" :preview-src-list="[message.file_url]"></el-image>
                      <span v-else><i class="el-icon-loading"></i></span>
                    </div>
                  </el-col>
                  <el-col v-else-if="message.type === 43">
                    <div class="record p-10 reciver">
                      <div v-if="message.file_url">
                        <video class="news_video" controls="controls" :src="message.file_url" type="video/mp4"></video>
                      </div>
                      <span v-else><i class="el-icon-loading"></i></span>
                    </div>
                  </el-col>
                  <el-col v-else-if="message.type === 34">
                    <div class="record p-10 reciver">
                      <div class="record" v-if="message.file_url">
                        <audio controls="controls" :src="message.file_url" type="audio/mp3"></audio>
                      </div>
                      <span v-else><i class="el-icon-loading"></i></span>
                    </div>
                  </el-col>
                  <el-col :span="24" v-if="message.type === 48">
                    <div class="infinite-item-content">定位</div>
                    <div class="popper__arrow"></div>
                  </el-col>
                  <el-col :span="24" v-if="message.type === 495">
                    <div class="infinite-item-content">链接</div>
                    <div class="popper__arrow"></div>
                  </el-col>
                  <el-col :span="24" v-if="message.type === 4933">
                    <div class="infinite-item-content">小程序</div>
                    <div class="popper__arrow"></div>
                  </el-col>
                  <el-col :span="24" v-if="message.type === 436207665">
                    <div class="infinite-item-content">红包</div>
                    <div class="popper__arrow"></div>
                  </el-col>
                  <el-col :span="24" v-if="message.type === 419430449">
                    <div class="infinite-item-content">转账</div>
                    <div class="popper__arrow"></div>
                  </el-col>
                  <el-col :span="24" v-if="message.type === 50">
                    <div class="infinite-item-content">语音视频聊天</div>
                    <div class="popper__arrow"></div>
                  </el-col>
                  <el-col :span="24" v-if="message.type === 42">
                    <div class="infinite-item-content">名片</div>
                    <div class="popper__arrow"></div>
                  </el-col>
                  <el-col :span="24" v-if="message.type === 855638065">
                    <div class="infinite-item-content">群直播</div>
                    <div class="popper__arrow"></div>
                  </el-col>
                </el-row>
              </div>
            </span>
          </div>
        </el-row>
      </el-col>
    </el-row>
    <el-drawer
      title="添加事项"
      :visible.sync="itemDrawer"
      :before-close="handleAddClose"
      direction="rtl"
      :append-to-body="true"
      size="40%">
      <div class="drawer-content">
        <el-form :model="itemForm" ref="itemForm" label-width="100px" size="mini">
          <el-form-item label="是否分配" prop="is_allot">
            <el-radio-group v-model="itemForm.is_allot" size="mini">
              <el-radio  label="1" border>暂不分配</el-radio>
              <el-radio  label="2" border>分配给办理人</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="公司名称" prop="company_id">
            <el-select v-model="itemForm.company_id"
              filterable remote reserve-keyword
              placeholder="请输入公司字号筛选公司"
              size="mini" clearable
              :remote-method="remoteCompanyMethod"
              :loading="loading">
              <el-option v-for="company in companies"
              :key="company.id"
              :label="company.company_name"
              :value="company.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单编号" prop="order_id">
            <el-select v-model="itemForm.order_id"
              filterable remote reserve-keyword
              placeholder="请输入订单号筛选订单（若无可不填写）"
              size="mini" clearable
              :remote-method="remoteOrderMethod"
              :loading="loading">
              <el-option v-for="order in orders"
              :key="order.id"
              :label="order.order_num"
              :value="order.id">
              </el-option>
            </el-select>
          </el-form-item>
           <el-form-item label="事项类型" prop="entries_type">
            <el-radio-group v-model="itemForm.entries_type" size="mini">
              <el-radio  label="1" border>外勤</el-radio>
              <el-radio  label="2" border>内勤</el-radio>
            </el-radio-group>
          </el-form-item>
          <span v-if="itemForm.is_allot === '2'">
            <el-form-item label="办理人" prop="user_id">
              <el-select v-model="itemForm.user_id" filterable placeholder="请选择办理人">
                <el-option
                  v-for="item in users"
                  :key="item.id"
                  :label="item.username"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="办理时间" prop="handle_time">
              <el-date-picker
                style="width: 100%"
                v-model="itemForm.handle_time"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="办理地点" prop="place_id"
            v-if="itemForm.entries_type === 1 || itemForm.entries_type === '1'">
              <el-select v-model="itemForm.place_id" filterable placeholder="请选择办理地点">
                <el-option
                  v-for="item in places"
                  :key="item.id"
                  :label="item.places_title"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </span>
          <el-form-item label="事项分类" prop="cates">
            <el-cascader
              v-model="itemForm.cates"
              placeholder="请选择创建事项的分类"
              :options="options"
              size="mini" style="width: 100%"
              :props="{ multiple: true }"
              filterable>
            </el-cascader>
          </el-form-item>
          <el-form-item label="内容详情" prop="item_content">
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入内容" v-model="itemForm.item_content">
              </el-input>
          </el-form-item>
        </el-form>
        <div style="padding-left: 2rem">
          <el-row>
            <el-col :span="24">
              <el-card shadow="hover">
                <el-upload
                  multiple
                  ref="upload"
                  action="#"
                  :headers="uploadHeader"
                  accept="image/png, image/jpeg, image/gif"
                  :limit="5"
                  :on-preview="handleLicensePreview"
                  :on-change="handleLicenseChange"
                  :on-remove="handleLicenseRemove"
                  :file-list="licenseList"
                  list-type="picture"
                  :auto-upload="false">
                  <el-link slot="trigger" type="primary">上传截图(最多可上传5张)</el-link>
                </el-upload>
              </el-card>
            </el-col>
          </el-row>
          <el-row style="padding-top: .4rem">
            <el-input v-paste="handleParse" type="textarea" placeholder="请点击此处，再粘贴复制的截图" />
          </el-row>
        </div>
        <el-row style="padding-top: .4rem; padding-bottom: 2rem; float: right">
          <el-col>
            <el-button type="primary" size="mini" @click="submitAddUpload('itemForm')">添加</el-button>
          </el-col>
        </el-row>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: 'QyGroupChat',
  props: {
    chatId: {
      type: String,
      default: () => {
        return null
      }
    },
    chatName: {
      type: String,
      default: () => {
        return null
      }
    }
  },
  data () {
    return {
      uploadHeader: {Authorization: localStorage.token},
      companies: [],
      selectId: null,
      selectName: '',
      messages: [],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 20 // 每页显示条数
      },
      messageLoading: false,
      complete: false,
      toBottom: true,
      oldHeight: 0,
      itemContent: [],
      selectCom: {
        id: null,
        company_name: null
      },
      formData: null,
      itemDrawer: false,
      licenseList: [],
      itemForm: {
        is_allot: '1',
        user_id: null,
        handle_time: null,
        place_id: null,
        company_id: null,
        order_id: null,
        entries_type: null,
        item_content: '',
        cates: []
      },
      loading: false,
      orders: [],
      users: [],
      places: [],
      options: [],
      is_checked: false,
      imgDefultSrc: '/static/qykj/img/qy_wx_def.png'
    }
  },
  computed: {
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === 'development' ? '' : 'https://weixin.qiyehuo.com'
      }
    }
  },
  watch: {
    chatId: function (val) {
      this.selectId = val || null
      this.messageLoading = false
      this.pageOption.currentPage = 1
      this.toBottom = true
      this.oldHeight = 0
      this.selectName = null
      this.messages = []
      if (val) this.getMessages(val, false)
    },
    chatName: function (val) {
      this.selectName = val || null
    }
  },
  methods: {
    getItemCates () {
      this.$axios.get('/api/item/cates')
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.options = data.data.cates
            this.users = data.data.users
            this.places = data.data.places
          }
        })
    },
    scrollBottom () {
      let scrollTop = this.$refs.messagesList.$el.scrollTop

      if (scrollTop === 0 && this.messageLoading) {
        if (!this.complete) this.pageOption.currentPage++
        this.toBottom = false
        this.getMessages(this.selectId, true)
        setTimeout(() => {
          let newHeight = this.$refs.messagesList.$el.scrollHeight
          this.$refs.messagesList.$el.scrollTop = newHeight - this.oldHeight
        }, 500)
      }
    },
    getMessages (chatID, isScroll) {
      if (isScroll) this.oldHeight = this.$refs.messagesList.$el.scrollHeight
      this.$axios.post('/api/admin/qy_wx_msg/group/messages?page=' + this.pageOption.currentPage, {chatID})
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.messages.unshift(...data.data.messages)
            if (this.pageOption.currentPage === 1) this.messageLoading = true
            this.$nextTick(() => {
              if (this.toBottom) {
                setTimeout(() => {
                  this.$refs.messagesList.$el.scrollTop = this.$refs.messagesList.$el.scrollHeight
                }, 500)
              }
            })
            this.itemContent = []
            this.complete = data.data.messages.length === 0
            if (data.data.companyId) this.selectCom.id = data.data.companyId
            if (data.data.companyName) {
              this.selectName = data.data.companyName
              this.selectCom.company_name = data.data.companyName
            }
          }
        })
    },
    handleAddMessageIndex (index) {
      let status = this.itemContent.indexOf(index)
      if (status === -1) {
        this.itemContent.push(index)
      } else {
        this.itemContent.splice(this.itemContent.indexOf(index), 1)
      }
    },
    handleAddItemEntry () {
      this.itemForm.item_content = ''
      if (this.itemContent.length > 0) {
        for (let j = 0; j < this.messages.length; j++) {
          let isIn = this.itemContent.indexOf(this.messages[j].message_id)
          if (isIn !== -1) {
            let megerStr = this.messages[j].user_nickname + ' ' + this.messages[j].message_time + ': ' + this.messages[j].content + ';' + '\n'
            this.itemForm.item_content += megerStr
          }
        }
      }
      this.companies = []
      if (this.selectCom.id) {
        this.companies.push(this.selectCom)
        this.itemForm.company_id = this.selectCom.id
      }
      this.formData = new FormData()
      this.itemDrawer = true
    },
    handleAddClose (done) {
      this.$refs['itemForm'].resetFields()
      this.licenseList = []
      done()
      this.formData = null
    },
    remoteCompanyMethod (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.searchItemCompanys(query)
        }, 200)
      } else {
        this.companies = []
      }
    },
    searchItemCompanys (query) {
      this.$axios.get('/api/admin/searchCompany?name=' + query)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.companies = data.data.companies
          }
        })
    },
    remoteOrderMethod (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.searchOrders(query)
        }, 200)
      } else {
        this.orders = []
      }
    },
    searchOrders (query) {
      this.$axios.get('/api/admin/searchOldOrders?name=' + query)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.orders = data.data.orders
          }
        })
    },
    handleLicensePreview (file) {},
    handleLicenseChange (file, fileList) {
      this.licenseList = fileList
    },
    handleLicenseRemove (file, fileList) {
      this.licenseList = fileList
      this.formData = null
      this.formData = new FormData()
      this.licenseList.forEach(file => this.formData.append('file[]', file.raw))
      for (let key in this.itemForm) {
        this.formData.append(key, this.itemForm[key])
      }
    },
    handleParse (e) {
      let file = null
      if (e.clipboardData && e.clipboardData.items[0] && e.clipboardData.items[0].type && e.clipboardData.items[0].type.indexOf('image') > -1) {
        file = e.clipboardData.items[0].getAsFile()
        let reader = new FileReader()
        reader.readAsDataURL(file)
        let that = this
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: 'ready',
            url: e.target.result
          }

          if (that.licenseList.length < 5) {
            that.licenseList.push(fileObj)
          } else {
            that.$message.error('最多可以上传5张')
          }
        }
      } else {
        this.$message.warning('上传的文件必须为图片')
      }
    },
    submitAddUpload (formName) {
      if (!this.itemForm.company_id) {
        this.$message.error('公司不能为空')
        return false
      }
      if (!this.itemForm.entries_type) {
        this.$message.error('事项类型不能为空')
        return false
      }
      if (this.itemForm.is_allot === '2' || this.itemForm.is_allot === 2) {
        if (!this.itemForm.user_id) {
          this.$message.error('办理人不能为空')
          return false
        }
        if (!this.itemForm.handle_time) {
          this.$message.error('办理时间不能为空')
          return false
        }
        if (this.itemForm.entries_type === 1 || this.itemForm.entries_type === '1') {
          if (!this.itemForm.place_id) {
            this.$message.error('办理地点不能为空')
            return false
          }
        }
      }
      if (this.itemForm.cates.length === 0) {
        this.$message.error('事项分类不能为空')
        return false
      }
      if (!this.itemForm.item_content) {
        this.$message.error('内容详情不能为空')
        return false
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.licenseList.length > 0) {
            this.licenseList.forEach(file => this.formData.append('file[]', file.raw))
          }
          for (let key in this.itemForm) {
            this.formData.append(key, this.itemForm[key])
          }
          this.$axios.post('/api/item/store', this.formData, this.itemForm.cates)
            .then((res) => {
              const { data } = res
              if (data.code === 0) {
                this.$message.success(data.msg)
                this.itemDrawer = false
                this.itemForm.company_id = null
                this.itemForm.order_id = null
                this.itemForm.place_id = null
                this.itemForm.cates = []
                this.itemForm.entries_type = null
                this.itemForm.is_allot = '1'
                this.itemForm.user_id = null
                this.itemForm.handle_time = null
                this.itemForm.item_content = []
                this.is_checked = false
                this.licenseList = []
                this.itemContent = []
                this.getMessages(this.selectId, false)
              }
            })
        }
      })
    },
    loadFile (url, name) {
      window.open(url)
      // this.$axios.get(url, {responseType: 'blob'})
      //   .then((res) => {
      //     let objectUrl = window.URL.createObjectURL(res.data)
      //     let link = document.createElement('a')
      //     link.href = objectUrl
      //     link.download = name
      //     link.click()
      //     setTimeout(function () {
      //       window.URL.revokeObjectURL(objectUrl)
      //     }, 100)
      //   })
    }
  },
  mounted () {
    this.getItemCates()
  }
}
</script>

<style lang="stylus" scoped>
  .messages-list
    min-height: calc(100vh - 210px)
    height: 6rem
    overflow-y: auto
    .messages-con
      padding: .4rem
      .message
        padding: .2rem
      .image_con
        padding: .2rem
    .infinite-item-content
      display: inline-block
      margin-top: .2rem
      padding: 0 .36rem 0 .36rem
      line-height: .9rem
      background-color: #eef0f5
    .popper__arrow
      position: absolute
      top: .04rem
      left: .36rem
      display: block
      margin-right: .06rem
      border-color: transparent
      border-style: solid
      border-width: .18rem
      border-top-width: 0
      border-bottom-color: #eef0f5
      filter: drop-shadow(0 2px 12px rgba(0,0,0,.03))
    .file_warp
      width: 200px
      background: #fff
      border-radius: 3px
      cursor: pointer
    .file_title
      display: flex
      -webkit-box-pack: justify
      justify-content: space-between
      padding: .1rem
      border-bottom: 1px solid #ebebeb
    .file_text
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis
      max-width: 3rem
    .file_sign
      font-size: .6rem
      line-height: .6rem
    .file_download
      display: block
      text-align: right
      padding: 0 .2rem
      font-size: .32rem
      line-height: 1.5
    .news_video
      max-width: 4rem
    .reciver
      background: #e5eeea
    .record
      margin-top: .06rem
      display: inline-block
    .p-10
      padding: .2rem
</style>



// WEBPACK FOOTER //
// src/common/QyGroupChat.vue